import { api } from '@/lib/api';
import type { VetDetailsRequest, VetDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/vet';

export async function save_vet_details(
  input: VetDetailsRequest,
): Promise<VetDetailsResponse> {
  const res = await api.post<VetDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_vet_details(): Promise<VetDetailsResponse | null> {
  const res = await api.get<VetDetailsResponse | null>(URL);
  return res.data;
}
